import { z } from 'zod';

import { PAGINATION_PAGE_SIZE_DEFAULT } from '~/constants/pagination';

import {
  zodInvoiceEmailListQueryParamsSchema,
  zodInvoiceEmailOrderBySchema,
} from '~/data/invoiceEmail';

export const validateInvoiceInboxSearch = z.object({
  limit: zodInvoiceEmailListQueryParamsSchema.shape.limit.catch(
    PAGINATION_PAGE_SIZE_DEFAULT,
  ),
  orderBy: zodInvoiceEmailOrderBySchema.catch('received_at'),
  page: z.number().int().min(0).catch(0),
  sortOrder: zodInvoiceEmailListQueryParamsSchema.shape.sortOrder.catch('DESC'),
});

export const defaultInvoiceInboxSearch = validateInvoiceInboxSearch.parse({});
